import script from "./AdminFeatureRequestDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminFeatureRequestDetailView.vue?vue&type=script&setup=true&lang=js"

import "./AdminFeatureRequestDetailView.vue?vue&type=style&index=0&id=45065d35&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45065d35"]])

export default __exports__